
document.addEventListener("DOMContentLoaded", function () {
    var elements = document.querySelectorAll(".in-view");
    var observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > 0) {
                entry.target.classList.add("animate");
            } else {
                entry.target.classList.remove("animate");
            }
           
            
		 
        });
    });
    elements.forEach((element) => {
        observer.observe(element);
    });
});
